module.exports = __webpack_public_path__ + "img/login.d785b366.svg";